import React from "react";

const Loader = () => {
  const loaderStyle = {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    background: `conic-gradient(
      from 0deg,
      #e4002b 0deg,
      #e4002b 120deg,
      rgba(228, 0, 43, 0.6) 180deg,
      rgba(228, 0, 43, 0.3) 240deg,
      rgba(228, 0, 43, 0.1) 300deg,
      transparent 360deg
    )`,
    animation: "spin 1s linear infinite",
    position: "relative",
  };

  const innerCircleStyle = {
    position: "absolute",
    top: "8px",
    left: "8px",
    width: "64px",
    height: "64px",
    backgroundColor: "white",
    borderRadius: "50%",
  };

  const loaderContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
    width: "100%",
  };

  const keyframesStyle = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;

  return (
    <div style={loaderContainerStyle}>
      <style>{keyframesStyle}</style>
      <div style={loaderStyle}>
        <div style={innerCircleStyle}></div>
      </div>
    </div>
  );
};

export default Loader;
